export const picklistProductIntegers = ['quantity'];
export const picklistProductFloats = [];
export const picklistProductIsoStrings = [];
export const picklistProductWhiteList = ['id', 'picklistId', 'productId', 'quantity'];
export const picklistProductOptimisticList = [
  ...picklistProductWhiteList,
  'picklist',
  'product',
];
